import { render, staticRenderFns } from "./AxProjectIcon.vue?vue&type=template&id=7ae2381e&scoped=true&"
import script from "./AxProjectIcon.vue?vue&type=script&lang=ts&"
export * from "./AxProjectIcon.vue?vue&type=script&lang=ts&"
import style0 from "./AxProjectIcon.vue?vue&type=style&index=0&id=7ae2381e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae2381e",
  null
  
)

export default component.exports